import { render, staticRenderFns } from "./CohortEdit.vue?vue&type=template&id=9a5cc450&scoped=true&"
import script from "./CohortEdit.vue?vue&type=script&lang=js&"
export * from "./CohortEdit.vue?vue&type=script&lang=js&"
import style0 from "./CohortEdit.vue?vue&type=style&index=0&id=9a5cc450&scoped=true&lang=css&"
import style1 from "./CohortEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5cc450",
  null
  
)

export default component.exports